"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridNewInMemoryPersistentStorage = void 0;
const DataGridNewEmptyStorageData_1 = require("./types/DataGridNewEmptyStorageData");
class DataGridNewInMemoryPersistentStorage {
    constructor() {
        this.store = Object.assign({}, DataGridNewEmptyStorageData_1.DATA_GRID_NEW_EMPTY_STORAGE_DATA);
    }
    save(payload) {
        this.store.columnSizes = payload.columnSizes;
        this.store.columnVisibility = payload.columnVisibility;
        this.store.columnOrders = payload.columnOrders;
    }
    read() {
        return Object.assign({}, this.store);
    }
}
exports.DataGridNewInMemoryPersistentStorage = DataGridNewInMemoryPersistentStorage;
//# sourceMappingURL=DataGridNewInMemoryPersistentStorage.js.map